import React from 'react';
import { companyInfo } from '../mockData';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_catching-energy/artifacts/9nd7ggbe_Screenshot%202026-02-02%20at%207.32.14%E2%80%AFPM.png" 
                alt="Catching Energy Sdn. Bhd."
                className="h-14 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              {companyInfo.tagline}
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-sm">
                <span className="text-green-500">✉</span>
                <a href={`mailto:${companyInfo.email}`} className="hover:text-green-500 transition-colors whitespace-nowrap">
                  {companyInfo.email}
                </a>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <span className="text-green-500">📞</span>
                <a href={`tel:${companyInfo.phone}`} className="hover:text-green-500 transition-colors">
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <span className="text-green-500">📍</span>
                <span>{companyInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="hover:text-green-500 transition-colors text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-green-500 transition-colors text-sm"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('collaboration')}
                  className="hover:text-green-500 transition-colors text-sm"
                >
                  Collaboration
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-green-500 transition-colors text-sm"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li>Rapid Thermal Treatment</li>
              <li>Custom Synthesis</li>
              <li>Biomass Conversion</li>
              <li>Waste Material Processing</li>
              <li>Carbon Production</li>
              <li>Graphene Manufacturing</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <button className="hover:text-green-500 transition-colors">Privacy Policy</button>
              <button className="hover:text-green-500 transition-colors">Terms of Service</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
